import { ReactNode } from "react";

export type LogLevel = "log" | "warn" | "error";

export interface LogProps {
  message: ReactNode;
  level: LogLevel;
  args?: Array<unknown>;
}

export const Log = (
  message: LogProps["message"],
  level: LogProps["level"],
  args?: LogProps["args"]
) => {
  // if (BUILD_TYPE != "production" && BUILD_TYPE != "test") {

  switch (level) {
    case "log":
      // eslint-disable-next-line no-console
      console.log(
        `${args && args.length > 0 ? `%c` : ""} RGS Admin FrontEnd: ${message}`,
        args ? { ...args } : ""
      );
      break;
    case "warn":
      // eslint-disable-next-line no-console
      console.warn(
        `${
          args && args.length > 0 ? `%c` : ""
        } RGS Admin FrontEnd [Warning]: ${message}`,
        args ? { ...args } : ""
      );
      break;
    case "error":
      // eslint-disable-next-line no-console
      console.error(
        `${
          args && args.length > 0 ? `%c` : ""
        } RGS Admin FrontEnd [Error]: ${message}`,
        args ? { ...args } : ""
      );
      break;
  }
  // }
};

export const ConsoleColors = {
  info: "background: blue; color: white",
};

export default Log;
